import shortid from "shortid";

export class Pessoas {
  ativado = true;
  apelidoFantasia = null;
  celular = null;
  cnpjCpf = null;
  naturezaSocial = null;
  nomeRazaoSocial = null;
  dataAbertura = null;
  dataNascimento = null;
  email = null;
  telefone = null;
  inscricaoEstadual = null;
  inscricaoEstadualRural = null;
  rg = null;
  contato = null;
  sexo = null;
  idTiposPessoa = [];
  endereco = null;
  cliente = null;
  fornecedor = null;
  transportadora = null;
  colaborador = null;
  prestadorServico = null;
  profissional = null;

  constructor(dados) {
    this.id = shortid.generate();
    this.naturezaSocial = dados.naturezaSocial;
    this.nomeRazaoSocial = dados.nomeRazaoSocial;
    this.apelidoFantasia = dados.apelidoFantasia;
    this.dataAbertura = dados.dataAbertura
      ? new Date(dados.dataAbertura)
      : null;
    this.dataNascimento = dados.dataNascimento
      ? new Date(dados.dataNascimento)
      : null;
    this.cnpjCpf = dados.cnpjCpf?.toString();
    this.inscricaoEstadual = dados.inscricaoEstadual;
    this.inscricaoEstadualRural = dados.inscricaoEstadualRural;
    this.rg = dados.rg;
    this.contato = dados.contato;
    this.email = dados.email;
    this.telefone = dados.telefone?.toString();
    this.celular = dados.celular?.toString();
    this.sexo = dados.sexo;
  }

  setEndereco(endereco) {
    if (endereco) {
      this.endereco = new Endereco(endereco);
    }
  }
  
  setCliente(cliente) {
    if (cliente) {
      this.cliente = new Cliente(cliente);
    }
  }

  setFornecedor(fornecedor) {
    if (fornecedor) {
      this.fornecedor = new Fornecedor(fornecedor);
    }
  }

  setTransportadora(transportadora) {
    if (transportadora) {
      this.transportadora = new Transportadora(transportadora);
    }
  }

  setColaborador(colaborador) {
    if (colaborador) {
      this.colaborador = new Colaborador(colaborador);
    }
  }

  setPrestadorServico(prestador) {
    if (prestador) {
      this.prestadorServico = new PrestadorServico(prestador);
    }
  }

  setProfissional(profissional) {
    if (profissional) {
      this.profissional = new Profissional(profissional);
    }
  }

  setTiposPessoa(tipoPessoaId) {
    if (tipoPessoaId) {
      this.idTiposPessoa.push(tipoPessoaId);
    }
  }
}

class Endereco {
  cep = null;
  logradouro = null;
  numero = null;
  bairro = null;
  complemento = null;
  descricao = null;
  padrao = true;
  cidade = null;
  cidadeId = null;
  estadoId = null;

  constructor(endereco) {
    this.cep = endereco.cep?.toString().replace(/[^0-9]/g, "");
    this.logradouro = endereco.logradouro?.trimStart().trimEnd();
    this.numero = endereco.numero?.toString().trimStart().trimEnd();
    this.bairro = endereco.bairro?.trimStart().trimEnd();
    this.complemento = endereco.complemento?.trimStart().trimEnd();
    this.descricao = endereco.descricao;
    this.cidade = endereco.cidade?.toString().trimStart().trimEnd();
  }

  setAtributo(name, value) {
    this[name] = value;
  }

  setCidade(cidadeId, estadoId) {
    this.cidadeId = cidadeId;
    this.estadoId = estadoId;
  }
}

class Cliente {
  grupoPessoaId = null;
  tipoContribuinteId = null;
  indicadorConsumidorFinal = null;
  mensagemVenda = null;
  limiteCompra = null;

  constructor(cliente) {
    this.grupoPessoaId = cliente.grupoPessoaId;
    this.tipoContribuinteId = cliente.tipoContribuinteId;
    this.indicadorConsumidorFinal = cliente.indicadorConsumidorFinal ?? true;
    this.mensagemVenda = cliente.mensagemVenda;
    if (cliente.limiteCompra) {
      this.limiteCompra = parseFloat(cliente.limiteCompra);
    }
  }

  setAtributo(name, value) {
    this[name] = value;
  }
}

class Fornecedor {
  limiteCompra = null;
  grupoPessoaId = null;

  constructor(fornecedor) {
    this.grupoPessoaId = fornecedor.grupoPessoaId;
    if (fornecedor.limiteCompra) {
      this.limiteCompra = parseFloat(fornecedor.limiteCompra);
    }
  }
  
  setAtributo(name, value) {
    this[name] = value;
  }
}

class Transportadora {
  localEmbarque = null;
  localDesembarque = null;
  rntc = null;
  grupoPessoaId = null;

  constructor(transportadora) {
    this.ufEmbarque = transportadora.ufEmbarque;
    this.localEmbarque = transportadora.localEmbarque;
    this.localDesembarque = transportadora.localDesembarque;
    this.rntc = transportadora.rntc;
    this.grupoPessoaId = transportadora.grupoPessoaId;
  }

  setAtributo(name, value) {
    this[name] = value;
  }
}

class Colaborador {
  grupoPessoaId = null;
  dataAdmissao = null;
  funcao = null;
  dataDemissao = null;
  vendedor = false;
  motorista = false;
  comissaoPrazo = null;
  comissaoVista = null;
  descontoMaximo = null;

  constructor(colaborador) {
    this.grupoPessoaId = colaborador.grupoPessoaId;
    this.dataAdmissao = colaborador.dataAdmissao;
    this.funcao = colaborador.funcao;
    this.dataDemissao = colaborador.dataDemissao;
    this.vendedor = colaborador.vendedor ?? false;
    this.motorista = colaborador.motorista ?? false;
    this.comissaoPrazo = colaborador.comissaoPrazo;
    this.comissaoVista = colaborador.comissaoVista;
    this.descontoMaximo = colaborador.descontoMaximo;
  }

  setAtributo(name, value) {
    this[name] = value;
  }
}

class PrestadorServico {
  profissao = null;
  grupoPessoaId = null;
  comissaoPrazo = null;
  comissaoVista = null;

  constructor(prestadorServico) {
    this.profissao = prestadorServico.profissao;
    this.grupoPessoaId = prestadorServico.grupoPessoaId;
    this.comissaoPrazo = prestadorServico.comissaoPrazo;
    this.comissaoVista = prestadorServico.comissaoVista;
  }

  setAtributo(name, value) {
    this[name] = value;
  }
}

class Profissional {
  profissao = null;
  grupoPessoaId = null;
  comissao = null;

  constructor(profissional) {
    this.profissao = profissional.profissao;
    this.grupoPessoaId = profissional.grupoPessoaId;
    this.comissao = profissional.comissao;
  }

  setAtributo(name, value) {
    this[name] = value;
  }
}